

















































































import { Component, Watch } from "vue-property-decorator";
import TokenUtil from "@/utils/TokenUtil";
import Header from "@/components/header/ULoginHeader.vue";
import Footer from "@/components/Footer.vue";
import AuthModule from "@/store/auth";
import CheckUserLogin from "@/utils/CheckUserLogin";
import UsersApi from "@/services/UsersApi";
import OrganizationUsersApi from "@/services/OrganizationUsers";
import StripeApi from "@/services/StripeApi";
import dayjs from "dayjs";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class URegisterInfo extends CheckUserLogin {
  // 削除ダイアログオフ
  private dialogDelete = false;

  // アカウント削除確認チェックボックス
  private checkbox = false;

  // 登録した日付をyyyy/mm/ddの表示形式に変換したものを格納
  private birthday = "";

  // アカウント登録した日付をyyyy/mm/ddの表示形式に変換したものを格納
  private createdAt = "";

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // Yesチェックボックスのオンオフの取得
  private get check() {
    return this.checkbox;
  }

  private async mounted() {
    await this.fetch();
  }

  @Watch("me")
  // アカウント情報の取得
  private async fetch() {
    if (this.me) {
      // // 日付の表示変更
      this.createdAt = String(dayjs(this.me.createdAt).format("YYYY/MM/DD"));
      if (this.me.userDetail && this.me.userDetail.birthday) {
        this.birthday = String(dayjs(this.me.userDetail.birthday).format("YYYY/MM/DD"));
      }
    }
  }

  // アカウント削除が押されたとき
  private async deleteAccount() {
    // Yesチェックボックスを空に
    this.checkbox = false;
    // 削除ダイアログをオン
    this.dialogDelete = true;
  }

  private async deleteItemCfm() {
    if (!this.me?.uuid) {
      return;
    }
    try {
      if (this.$route.name === "URegisterInfo") {
        if (this.me.roleId === 2) {
          await UsersApi.instance.deleteUserByUuid(this.me.uuid || this.me?.uuid);
          if (this.me && this.me.cusId) {
            const subscriptionRes = await StripeApi.instance.getSubscriptionByCusId(this.me.cusId);
            const subscription = subscriptionRes.data.data;

            if (subscription.length) {
              await StripeApi.instance.deleteSubscriptionBySubId(subscription[0].id, this.me.uuid);
            }
          }
        } else {
          await OrganizationUsersApi.instance.deleteOrganizationUserByUuid(this.me.uuid || this.me?.uuid);
        }
      }
      // アカウント削除と同時にログアウトしトップページに戻る
      this.logout();
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // 削除ダイアログ オフ
  private closeDelete() {
    this.dialogDelete = false;
  }

  // ログアウト
  private logout() {
    TokenUtil.removeToken();
    AuthModule.commitMe(null);
    // ログアウトと同時にトップページに戻る
    this.$router.push("/");
  }
}
